// ===============================================
// THIS IS A GENERATED FILE - Do NOT edit manually
//
// @see libs/data-access/generator/README.md
//
// ===============================================

import { EndpointParams as CheckAccessByRoleEndpointParams } from '../api/checkAccessByRole';
import { EndpointParams } from '../api/getAccessByPage';

const baseKey = 'iam';

export const iamKeys = {
  accessByRole: ({
    features,
    permissions,
  }: {
    features: CheckAccessByRoleEndpointParams['features'];
    permissions: CheckAccessByRoleEndpointParams['permissions'];
  }) => [baseKey, 'accessByRole', { features, permissions }],
  all: () => [baseKey],
  page: ({ page }: { page: Awaited<EndpointParams['params']>['page'] }) => [
    baseKey,
    'page',
    { page },
  ],
  site: () => [baseKey, 'site'],
};
